import React, { PureComponent } from 'react';
import { array, bool, func, object, oneOfType, string } from 'prop-types';
import classNames from 'classnames';

import './Card.scss';

export class Card extends PureComponent {
  static propTypes = {
    className: string,
    raised: bool,
    raiseOnHover: bool,
    roundedCorner: bool,
    hoverFocus: bool,
    children: oneOfType([array, object]),
    onCardClick: func,
    onMouseEnter: func,
    onMouseLeave: func
  };

  static defaultProps = {
    hoverFocus: false,
    raised: false,
    raiseOnHover: false,
    roundedCorner: false,
    onMouseEnter: function() {},
    onMouseLeave: function() {}
  };

  render() {
    const {
      className,
      raised,
      raiseOnHover,
      roundedCorner,
      hoverFocus,
      children,
      onCardClick,
      onMouseEnter,
      onMouseLeave
    } = this.props;
    const cardClass = classNames({
      card: true,
      [className]: !!className,
      raised: raised,
      'raise-up': raiseOnHover,
      rounded: roundedCorner,
      'hover-focus': hoverFocus
    });

    return (
      <div className={cardClass} onClick={onCardClick} onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave}>
        {children}
      </div>
    );
  }
}

export default Card;
